import {
  mapState,
  mapMutations,
  mapGetters
} from "vuex";

let fromDetail = false;

function checkPath(to) {
  return (
    // 详情
    to.path.includes('detail') ||
    to.path.includes('Detail') ||
    to.path.includes('edit') ||
    // 查看
    to.path.includes('view') ||
    to.path.includes('Hy') ||
    to.path.includes('hy') ||
    // 费用表详情
    to.path.includes('fee') ||
    // 车队分组车辆列表
    to.path.includes('vehicle/groupList') ||
    // 预支款付款记录
    (to.path.includes('initial') && to.path.includes('PaymentRecord')) ||
    // 证件
    (to.path.includes('document') && !to.path.includes('documents')) ||
    // 保险
    (to.path.includes('insurance') && !to.path.includes('insurances')) ||
    // 带参
    to.fullPath.includes('?')
  )
}

const minin = {
  data() {
    return {
      // table高度默认没有tab--610，在Table组件中设置
      // 有一层tab的table高度--550
      tableHeight: 550,
      // 有两层tab的table高度--500
      tableHeight2: 500,
      tabIdx: 0,
      tabData: [],
      formInline: {},
      formCtrl: [],
      page: 1,
      limit: 10,
      total: 0,
      tableData: [],
      getTotalProperty: [],
      loading: false,
      getListUrl: 'rec',
      baseParams: [],
      delUrl: 'delre',
      getOptionUrl: 'index',
      btns: [],
      selection: [],
      mform: {},
      mformCtrl: [],
      modalSubmitUrl: 'addedu',
      searchKeyOptions: [],
      allBtnWidth: '100px',
      // 储存初始值，用于重置
      MONTH: null,
    };
  },
  computed: {
    ...mapState([
      'user',
      'store',
    ]),
    ...mapGetters([
      'tabIdxMemo',
    ]),
    DATE_OBJ() {
      const date = new Date()
      const y = date.getFullYear() + ''
      let m = date.getMonth() + 1
      let d = date.getDate()
      let s = date.getTime()
      m > 9 ? null : m = '0' + m
      d > 9 ? null : d = '0' + d
      return {
        y, m, d, s
      }
    },
    DATE() {
      const date = new Date()
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      m > 9 ? null : m = '0' + m
      d > 9 ? null : d = '0' + d
      return `${y}-${m}-${d}`
    },
    CURR_MONTH() {
      const date = new Date()
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      m > 9 ? null : m = '0' + m
      // console.log(y, m)
      return `${y}-${m}`
    },
    LAST_MONTH() {
      const date = new Date()
      const y = date.getFullYear()
      let m = date.getMonth()
      m > 9 ? null : m = '0' + m
      // console.log(y, m)
      return `${y}-${m}`
    },
  },
  methods: {
    ...mapMutations(['setTabIdx', 'setState']),
    Export(name = 'test') {
      this.$confirm("确定要导出文件到Excel?", "导出提示", {
        //这里是加一个导出提示，根据个人喜好，可加可不加   
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        setTimeout(() => {
          var xlsxParam = {
            // raw: true
          } // 导出的内容只做解析，不进行格式转换
          const eTable = document.querySelector('.table-wrap .el-table')
          let fix = document.querySelector('.el-table__fixed-right');
          let wb;
          if (fix) { //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
            wb = this.$XLSX.utils.table_to_book(eTable.removeChild(fix), xlsxParam);
            eTable.appendChild(fix);
          } else {
            wb = this.$XLSX.utils.table_to_book(eTable);
          }
          // let tables = document.getElementById('eTable');   //这里是绑定元素，输入你要导出的table表格的id
          // let table_book = this.$XLSX.utils.table_to_book(tables, xlsxParam);
          const table_write = this.$XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "array",
          });
          try {
            this.$FileSaver.saveAs(
              new Blob([table_write], {
                type: "application/octet-stream"
              }), `${name}.xlsx` //这里是文件名
            );
          } catch (e) {
            if (typeof console !== "undefined") console.log(e, table_write);
          }
          return table_write;
        }, 500)
      })
    },
    onSizeChange(n) {
      // console.log(n);
      this.limit = n;
      this.getList();
    },
    onCurrentChange(n) {
      // console.log(n);
      this.page = n;
      this.getList();
    },
    onSelectionChange(arr) {
      this.selection = [...arr]
      // console.log('selection', this.selection);
    },
    onToggleTab({
      index
    }) {
      this.tabIdx = index;
      this.getList();
    },
    onSearch(form) {
      // 清空选中状态
      this.selection = [];
      if (this.$refs["table"] && this.$refs["table"].clearSelection) {
        this.$refs["table"].clearSelection();
      }

      this.formInline = {
        ...form
      };
      // console.log({ ...this.formInline });
      this.getList();
    },
    // 普通下拉组件变化搜索
    onSearchItemChange({
      key
    }) {
      if (['starttime', 'edittime', 'fleet', 'month', 'year'].includes(key)) {
        this.getList()
        // console.log('formInline', { ...this.formInline })
      }
    },
    // 复合组件变化搜索
    onComSearchChange({
      key,
      value
    }) {
      // console.log(key, value)
      if (key) this.formInline[key] = value
      // console.log('formInline', { ...this.formInline })
    },
    onReset() {
      console.log("onReset");
      // console.log(this.$refs)
      const comFormCtrl = this.$refs['comFormCtrl']
      comFormCtrl && comFormCtrl.reset()
      const comFormDate = this.$refs['comFormDate']
      comFormDate && comFormDate.reset()
      const obj = {}
      this.formCtrl.map(v => {
        obj[v.keyName] = null
      })
      this.searchKeyOptions.map(v => {
        obj[v.value] = null
      })
      this.baseParams.map(v => {
        if (v == 'year') {
          // 重置为默认年份
          // obj[v] = this.DATE_OBJ.y
        } else if (['month'].includes(v)) {
          // 重置为默认月份
          obj[v] = this.MONTH || null
        } else {
          obj[v] = this.formInline[v]
        }
      })
      // console.log(obj)
      this.formInline = obj;
      // 清除储存的搜索条件
      const path = this.$route.path
      this.setState({
        key: 'formInline' + path,
        value: obj,
      })
      // console.log('formInline', { ...this.formInline })
      this.page = 1;
      this.getList();
    },
    delete(id) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(id)
        this.delReq(id);
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    delReq(id) {
      this.loading = true
      let url = `${this.baseUrl}/${this.delUrl}`;
      const params = {
        userid: this.user.id,
        id,
      }

      this.delParamsPackage(params)

      console.log(url, { ...params })

      this.post(url, params, ({
        msg
      }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '删除失败，请稍后重试！'
        });
      })
    },

    delParamsPackage(params) {
      console.log('params', { ...params })
    },

    getList(staticfresh) {
      this.loading = true
      // console.log('loading', this.loading)
      if (!staticfresh) {
        this.tableData = [];
      }
      let url = `${this.baseUrl}/${this.getListUrl}`;
      const params = {
        userid: this.user.id,
        page: this.page,
        limit: this.limit,
      }
      const object = this.formInline
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          params[key] = object[key];
        }
      }
      // console.log('formInline', { ...this.formInline })
      // console.log(url, params)
      this.post(url, params, (res) => {
        this.loading = false
        // console.log('list', res.data)
        this.tableDataHandler(res);
        if (this.$refs.table) {
          // console.log(this.$refs.table.$el)
          this.$refs.table.setScrollTop()
        }
      }, err => {
        this.loading = false
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    handleClick() {
      // console.log(this.activeName)
      this.formInline.month = this.activeName;
      this.getList();
    },
    dataObjHandler(v) {
      const o = {}
      for (const key in v) {
        if (Object.hasOwnProperty.call(v, key)) {
          const ele = v[key]
          if (key.includes('time') && (typeof ele === 'string') && ele.includes(' ')) {
            const arr = ele.split(' ')
            o[key] = arr[0];
          } else {
            o[key] = v[key];
          }
        }
      }
      return o
    },
    tableDataHandler(res) {
      if (typeof res === 'string') {
        this.$message({
          type: 'error',
          message: res
        });
      } else {
        const {
          count,
          data
        } = res
        this.total = count
        if (data && data.length) {
          // console.log(data)
          // this.tableData = [...data]
          this.tableData = data.map(v => {
            return this.dataObjHandler(v)
          })
        }
      }
    },
    getTotal(param) {
      const {
        columns,
        data
      } = param;
      // console.log(param)
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0 && column.type !== 'selection') {
          // console.log({...column}, {...data})
          sums[index] = '合计';
          return;
        }
        if (columns[0].type === 'selection' && index === 1) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value)) && this.getTotalProperty.includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            // console.log(value, prev, curr, 11111)
            if (!isNaN(value)) {
              return this.keep2(Number(prev) + Number(curr));
            } else {
              return this.keep2(prev);
            }
          }, 0);
          // sums[index] += ' 元';
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    keep2(n) {
      return (Number(n)).toFixed(2)
    },
    showDialog(str = 'dialog') {
      this.$refs[str] && this.$refs[str].show()
    },
    hideDialog(str = 'dialog') {
      typeof str == 'string' ? null : str = 'dialog'
      this.$refs[str] && this.$refs[str].hide()
    },
    getFleet() {
      this.post(`base/getmyfleet`, {}, this.setFleet, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setFleet({ team }) {
      // console.log('team', team)
      // console.log('formCtrl', this.formCtrl)
      this.formCtrl.map(c => {
        if (c.keyName == 'fleet' && team && team.length) {
          c.options = team.map(v => {
            return {
              label: v.nickname,
              value: v.id,
            }
          })
        }
      })
      this.$forceUpdate()
    },
    setCtrlOption(v, team, key1, key2) {
      v.options = [{
        label: '全部',
        value: ''
      },]
      team.map(c => {
        v.options.push({
          label: c[key1 || 'name'],
          value: c[key2 || 'id'],
        })
      })
    },
    setQueryParams() {
      const object = this.$route.query
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          this.formInline[key] = object[key];
        }
      }
      // console.log()
    },
    getOptions(params = {}) {
      this.post(`${this.baseUrl}/${this.getOptionUrl}`, params, this.setOptions, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setOptions(res) {
      console.log(res, 110000)
    },
    onModalChange({
      key,
      value
    }) {
      // console.log(key, value)
      // console.log(key === 'money')
      if (key.includes('photo')) {
        this.mform[key] = value.map(v => {
          let result = v
          if (v.response && v.response.photo) {
            result = {
              url: v.response.photo
            }
          }
          return result
        })
      } else {
        // this.mform[key] = value;
        this.$set(this.mform, key, value)
      }
      // console.log({ ...this.mform })
    },
    onModalSubmit() {
      // console.log({ ...data })
      // console.log({ ...this.mform })
      if (this.loading) return;
      this.loading = true
      let url = `${this.baseUrl}/${this.modalSubmitUrl}`;
      const params = {
        userid: this.user.id,
      }
      this.paramsPackage(params, this.mform)
      console.log(url, params)
      this.post(url, params, ({
        msg
      }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    paramsPackage(params, object) {
      // console.log({ ...params })
      // console.log({ ...object })
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key]
          if (value && typeof value === 'object') {
            console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = {
                  url: v.response.photo
                }
              }
              return result
            })
          } else {
            params[key] = value;
          }
        }
      }
    },
    doLayout() {
      // console.log(this.$refs.table)
      if (this.$refs.table && this.$refs.table.doLayout) {
        this.$refs.table.doLayout()
      }
    },
  },
  updated() {
    this.doLayout();
  },
  created() {
    // console.log('formInline', { ...this.formInline })
    // 初始化搜索数据，否则无法检测到值变化
    this.formCtrl.map(v => {
      const val = this.formInline[v.keyName]
      // 直接赋值有时候会引起渲染失效，不保险
      // this.formInline[v.keyName] = val || null
      this.$set(this.formInline, v.keyName, val || null)
    })
    // console.log('formInline', { ...this.formInline })
  },
  mounted() {
    // // 检索对象formInline有month参数且没有值，默认赋值上个月，同时储存为重置默认值
    // if (Object.prototype.hasOwnProperty.call(this.formInline, 'month') && !this.formInline.month) {
    //   // 在这里默认赋值上月，如有默认本月的在页面中的created中赋值
    //   this.MONTH = this.LAST_MONTH
    //   this.$set(this.formInline, 'month', this.LAST_MONTH)
    //   this.$forceUpdate()
    // }
    // console.log(this.MONTH)
    // 获取存储的搜索参数
    // console.log('store', { ...this.store })
    const path = this.$route.path
    // 获取存储的页码
    if (this.store['page' + path] && !this.$route.fullPath.includes('?')) {
      if (this.nosetpage != 1) {
        this.page = this.store['page' + path]
      }
    }
    if (this.store['limit' + path]) {
      this.limit = this.store['limit' + path]
    }
    // console.log('fromDetail', fromDetail)
    if (this.store['formInline' + path] && fromDetail && !this.$route.path.includes('/done')) {
      this.formInline = this.store['formInline' + path]
      this.$forceUpdate()
      console.log('formInline', { ...this.formInline });
    }

    // 没有基础固定传参则直接获取数据，否则在各个页面内添加逻辑后自行获取数据
    if (!this.baseParams.length && !Object.keys(this.$route.query).length) {
      // 恢复状态后再搜索
      this.$nextTick(this.getList)
    }
    // this.tabIdx = this.tabIdxMemo(this.$route.path) || 0
  },
  beforeRouteEnter(to, from, next) {
    // console.log(`Route Enter`)
    // console.log(`from ${from.path}`)
    // console.log(`to ${to.path}`)
    fromDetail = checkPath(from)
    // 一定要调用next
    next()
  },
  beforeRouteLeave(to, from, next) {
    // console.log(`Route Leave`)
    // console.log(`from ${from.path}`)
    // console.log(`to ${to.path}`)
    // 监听到页面离开时调用
    // to: 即将要进入的目标的路由对象
    // from: 当前导航正要离开的路由
    // next: 是一个function，一定要调用该方法，否则路由不会跳转。
    // console.log(to)
    // console.log(from)
    // this.setTabIdx({
    //   path: from.path,
    //   idx: this.tabIdx,
    // })
    // console.log(to.path)
    // 跳转详情页存页码，否则重置为1
    const path = this.$route.path
    if (checkPath(to)) {
      this.setState({
        key: 'page' + path,
        value: this.page,
      })
      this.setState({
        key: 'limit' + path,
        value: this.limit,
      })
      this.setState({
        key: 'formInline' + path,
        value: this.formInline,
      })
      this.setState({
        key: 'scrollTop' + path,
        value: this.$refs.table.scrollTop,
      })
      // console.log(this.$route.path)
      // console.log('scrollTop', this.$refs.table.scrollTop)
    } else {
      this.setState({
        key: 'page' + path,
        value: 1,
      })
      this.setState({
        key: 'limit' + path,
        value: 10,
      })
      // const o = {}
      // this.baseParams.map(v => {
      //   o[v] = this.formInline[v]
      // })
      // this.setState({
      //   key: 'formInline',
      //   value: o,
      // })
      this.setState({
        key: 'scrollTop' + path,
        value: 0,
      })
    }
    // 一定要调用next
    next()
  },
}

export default minin